import {ApplicationError} from './application-error.model';
export const INVALID_RESERVATION_ERROR_CODE = 'invalidReservation';

export class BusinessError extends ApplicationError {
  constructor(code: string, message: string) {
    super(code, message);
  }
}




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/errors/business-error.model.ts